<template>
  <div v-if="isTipsLoaded && isEnabled" class="tips__wrapper">
    <slot v-if="!hiddenTitle" name="title">
      <div class="tips__title">
        {{ $t`Ответы на частые вопросы` }}
      </div>
    </slot>
    <div ref="container">
      <div class="block-container">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { captureException } from "@sentry/vue";
import { getSwitchers } from "@/api/general";
import { VueCookieNext } from "vue-cookie-next";

export default {
  props: {
    questionPageName: {
      type: String,
      required: true,
    },
    hiddenTitle: {
      type: Boolean,
      default: false,
    },
    wrapped: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isTipsLoaded: false,
      isEnabled: false,
    };
  },
  mounted() {
    this.loadGuide();
    this.getGuideState();
  },
  methods: {
    async getGuideState() {
      const { is_guide_enabled } = await getSwitchers();
      this.isEnabled = is_guide_enabled;
    },
    loadGuide() {
      const env = window.mybank_settings.mode;
      let lang = VueCookieNext.getCookie("locale") == "kk-KZ" ? "kz" : "ru";
      const envUrls = {
        development: "https://guide.kaspi.kz/client/snippet",
        staging: "https://guide.kaspi.kz/client/snippet",
        testing: "https://guide.kaspi.kz/client/snippet",
        production: "https://guide.kaspi.kz/client/snippet",
        sandbox: "https://guide.kaspi.kz/client/snippet",
      };
      import("jquery").then(({ default: $ }) => {
        window.$ = window.jQuery = $;

        const wrappedQuery = this.wrapped ? "&wrapped=true" : "";

        $.get(
          `${envUrls[env]}/KaspiKzQuestionGroup/?page=${this.questionPageName}${wrappedQuery}&lang=${lang}`
        )
          .then((response) => {
            setTimeout(() => {
              $(this.$refs.container).html(response);
            }, 400);

            this.$emit("loaded");
            this.isTipsLoaded = true;
            return Promise.resolve();
          })
          .catch((err) => {
            captureException(err);
          });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.tips {
  &__wrapper {
    text-align: left;
  }

  &__title {
    padding: 10px 15px 6px;
    line-height: 1.2;
    font-size: 12px;
    color: #a8a8a8;
    text-transform: uppercase;
  }
}
</style>
